import {IProductState} from '../../../api/products/types';

export const selectProducts = (state: IProductState) => state.products.data.products;
export const selectTotalRecords = (state: IProductState) => state.products.data.page.total;
